import { SjBreakPoints } from '../../models/interfaces';

export const DEFAULT_BREAKPOINTS: SjBreakPoints = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920,
  xxl: 2560,
};
